import axios from "axios";
import { API_BASE } from "@/constants/env";

export async function getVenues() {
  const res = await axios.get(`${API_BASE}/venues`);
  return res.data;
}

export async function exportVenuesCsv(venues) {
  return axios.post(`${API_BASE}/venues/export`, venues, { responseType: "blob" });
}

export async function emailVenues(payload) {
  return axios.post(`${API_BASE}/venues/email`, payload);
}